// Canwood Botanical — scroll reveal (progressive enhancement).
// Adds `cb-is-visible` to `[data-cb-reveal]` / `[data-cb-reveal-stagger]`
// elements as they scroll into view. Fully guarded: if reduced motion is
// requested, nothing is hidden and this does nothing.

(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /** @type {IntersectionObserver | null} */
  let observer = null;

  const STAGGER_STEP = 90; // ms between staggered children

  const reveal = (el) => {
    // Stagger children if requested
    if (el.hasAttribute('data-cb-reveal-stagger')) {
      Array.from(el.children).forEach((child, i) => {
        child.style.transitionDelay = `${i * STAGGER_STEP}ms`;
      });
    }
    el.classList.add('cb-is-visible');
  };

  const enable = () => {
    // Flag support so the CSS initial-hidden state activates only now.
    document.documentElement.classList.add('cb-reveal-enabled');

    observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          reveal(entry.target);
          observer?.unobserve(entry.target);
        }
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    scan();
  };

  const scan = (root = document) => {
    if (!observer) return;
    root
      .querySelectorAll('[data-cb-reveal]:not(.cb-is-visible), [data-cb-reveal-stagger]:not(.cb-is-visible)')
      .forEach((el) => observer.observe(el));
  };

  const init = () => {
    if (reduceMotion.matches) return; // leave everything visible
    enable();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // Re-scan when the Theme Editor injects/replaces a section.
  document.addEventListener('shopify:section:load', (event) => {
    if (!observer) return;
    const target = event.target instanceof HTMLElement ? event.target : document;
    scan(target);
  });
})();
